import styled from "styled-components";
import * as colors from "src/styles/constants/colors";
import * as radius from "src/styles/constants/radius";
import * as spacing from "src/styles/constants/spacing";

type LabelProps = {
  weight?: "normal" | "bold";
};

type TextAreaProps = {
  resize?: "none" | "vertical" | "horizontal";
};

const Container = styled.div`
  width: 100%;
  padding: ${spacing.space_xs};
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Label = styled.label<LabelProps>`
  font-size: 14px;
  width: fit-content;
  font-weight: ${({ weight }) => weight || "normal"};
`;

const TextArea = styled.textarea<TextAreaProps>`
  width: 100%;
  min-height: 100px;
  padding: 0.375rem;
  font-size: 14px;
  line-height: 18px;
  border: 1px solid ${colors.grey35};
  border-radius: ${radius.medium};
  background-color: white;
  resize: ${({ resize }) => resize || "vertical"};
`;

export { Container, Label, TextArea };
